module.exports = __webpack_public_path__ + "img/income.31157798.png";